export default {"src":"/_next/static/media/Solution0.194608aa.svg","height":49,"width":49};